import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const persistentSearchLayoutDefaultVariants = {}
const persistentSearchLayoutCompoundVariants = []

const persistentSearchLayoutSlotNames = [
  [
    "searchFrame",
    "persistent-search-layout__searchFrame"
  ],
  [
    "searchHeader",
    "persistent-search-layout__searchHeader"
  ],
  [
    "searchLayout",
    "persistent-search-layout__searchLayout"
  ],
  [
    "mapPanel",
    "persistent-search-layout__mapPanel"
  ],
  [
    "mapPanelMobileActive",
    "persistent-search-layout__mapPanelMobileActive"
  ],
  [
    "mapFallbackContainer",
    "persistent-search-layout__mapFallbackContainer"
  ],
  [
    "mapFallbackText",
    "persistent-search-layout__mapFallbackText"
  ],
  [
    "contentPanel",
    "persistent-search-layout__contentPanel"
  ],
  [
    "contentPanelDesktopBottomInset",
    "persistent-search-layout__contentPanelDesktopBottomInset"
  ],
  [
    "contentPanelMobileMapActive",
    "persistent-search-layout__contentPanelMobileMapActive"
  ],
  [
    "mobileMapSearchBarOverlay",
    "persistent-search-layout__mobileMapSearchBarOverlay"
  ],
  [
    "contentPanelChildren",
    "persistent-search-layout__contentPanelChildren"
  ]
]
const persistentSearchLayoutSlotFns = /* @__PURE__ */ persistentSearchLayoutSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, persistentSearchLayoutDefaultVariants, getSlotCompoundVariant(persistentSearchLayoutCompoundVariants, slotName))])

const persistentSearchLayoutFn = memo((props = {}) => {
  return Object.fromEntries(persistentSearchLayoutSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const persistentSearchLayoutVariantKeys = []
const getVariantProps = (variants) => ({ ...persistentSearchLayoutDefaultVariants, ...compact(variants) })

export const persistentSearchLayout = /* @__PURE__ */ Object.assign(persistentSearchLayoutFn, {
  __recipe__: false,
  __name__: 'persistentSearchLayout',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: persistentSearchLayoutVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, persistentSearchLayoutVariantKeys)
  },
  getVariantProps
})